const th = {
	sidebar: {
		userInfo: 'ข้อมูลผู้ใช้งาน',
		submitForm: 'ยื่นหนังสือแบบรับรองตนเอง',
		submissionStatus: 'สถานะการยื่นแบบรับรองตนเอง',
		downloadManual: 'ดาวน์โหลดคู่มือการใช้งานระบบ',
		signOut: 'ออกจากระบบ',
		selectForm: 'เลือกฟอร์มที่ต้องการ',
		formFor2568: 'แบบฟอร์มสำหรับ ประกาศปี 2568',
		selectVersion: 'กรุณาเลือกเวอร์ชัน',
		cancel: 'ยกเลิก',
		download: 'ดาวน์โหลด',
		newVersion: 'พบเวอร์ชันใหม่',
		newVersionMsg: (v) => `ระบบมีการอัปเดตเป็นเวอร์ชัน ${v} กรุณากดปุ่มด้านล่างเพื่อรีเฟรชหน้าจอ หรือกด Shift + F5`,
		refresh: 'รีเฟรชหน้าจอ',
	},
	signIn: {
		subtitle: 'สำหรับผู้ยื่นแบบรับรองตนเอง',
		nationalID: 'เลขประจำตัวบัตรประชาชน',
		password: 'รหัสผ่าน',
		nationalIDRequired: 'กรุณากรอกบัตรประชาชนผู้ใช้งาน',
		passwordRequired: 'กรุณากรอกรหัสผ่าน',
		invalidCredentials: 'เลขประจำตัวประชาชนหรือรหัสผ่านไม่ถูกต้อง',
		register: 'ลงทะเบียนผู้ประกอบการ',
		submit: 'เข้าสู่ระบบ',
		loading: 'กำลังเข้าสู่ระบบ...',
	},
	registration: {
		title: 'ลงทะเบียนระบบ Data Portal',
		nationalID: 'หมายเลขบัตรประจำตัวประชาชน',
		search: 'ค้นหา',
		firstname: 'ชื่อ*',
		lastname: 'นามสกุล*',
		email: 'อีเมล*',
		phone: 'เบอร์โทรศัพท์*',
		back: 'ย้อนกลับ',
		confirm: 'ยืนยันการสมัคร',
	},
	registrationModal: {
		successMsg: 'คุณได้ยืนยันการสมัคร',
		failMsg: 'ผู้ใช้งานนี้ได้เคยลงทะเบียนแล้ว',
		incorrectIdMsg: 'ไม่มีหมายเลขรหัสบัตรประชาชนนี้',
		ok: 'ตกลง',
	},
	form: {
		missingExplanation: 'กรุณาระบุคำชี้แจง',
		noNewFilesExplanation: 'ไม่มีเอกสารใหม่ที่แนบ กรุณาระบุคำชี้แจงเพื่อส่งกลับเจ้าหน้าที่',
		explanation: 'คำชี้แจง',
		pageTitle: 'ยื่นแบบหนังสือรับรองตนเอง',
		noNewFilesTitle: 'ยื่นแบบโดยไม่มีเอกสารใหม่',
		attachFileTitle: 'แนบเอกสารเพิ่มเติม',
		attachFileContent: 'คุณแน่ใจที่จะแนบเอกสารสำหรับยื่นแบบหนังสือรับรองตนเองหรือไม่?',
		modifyInfoTitle: 'ปรับปรุงข้อมูลเอกสาร',
		modifyInfoContent: 'คุณแน่ใจที่จะส่งข้อมูลที่ถูกปรับปรุงชุดนี้แล้วหรือไม่?',
		submitTitle: 'ยื่นแบบหนังสือรับรองตนเอง',
		submitContentOrg: 'นิติบุคคล',
		submitContentPerson: 'บุคคลธรรมดา',
		submitContentPrefix: (type) => `คุณกำลังยื่นแบบหนังสือรับรองตนเอง​ในนามของ "${type}"`,
		submitContentSuffix: (count) => `* หมายเหตุ เอกสารแนบที่แนบมาพร้อมคำขอนี้มีจำนวนทั้งสิ้น ${count} ไฟล์`,
		submitPreviewLink: 'คุณสามารถดูตัวอย่างหนังสือรับรองตนเองก่อนยื่นได้',
		here: 'ที่นี่',
		continueQuestion: 'คุณต้องการดำเนินการต่อหรือไม่?',
		submit: 'ยื่นแบบ',
		missingPersonalInfoTitle: 'ข้อมูลส่วนตัวของผู้ยื่นแบบไม่ครบถ้วน',
		missingPersonalInfoText: 'กรุณาตรวจสอบและปรับปรุงข้อมูลในเมนู "ข้อมูลผู้ใช้งาน" (ท่านยังไม่ได้ระบุคำนำหน้าชื่อ)',
		missingCompanyInfoTitle: 'ข้อมูลบริษัทไม่ครบถ้วน',
		missingCompanyInfoText: 'กรุณาตรวจสอบและปรับปรุงข้อมูลในเมนู "ข้อมูลผู้ใช้งาน" (ท่านยังไม่ได้ระบุคำนำหน้าชื่อบริษัท)',
		invalidAddressTitle: 'ข้อมูลที่อยู่ไม่ถูกต้อง หรือรูปแบบผิด',
		invalidAddressText: 'กรุณาตรวจสอบและปรับปรุงข้อมูลในเมนู "ข้อมูลผู้ใช้งาน" และกรอกข้อมูลลงฟอร์มให้ถูกต้อง',
		processingTitle: 'กำลังดำเนินการ',
		processingText: 'กรุณารอสักครู่...',
		processingFooter: 'โปรดรอสักครู่....',
		error400Title: 'ข้อมูลคำขอไม่ถูกต้อง',
		error500Title: 'เกิดข้อผิดพลาดจากระบบ',
		error500Text: 'กรุณาลองใหม่ภายหลัง',
		error408Title: 'หมดเวลาในการทำรายการ',
		errorCheckStatus: 'กรุณาตรวจสอบคำขอในเมนู สถานะการยื่นแบบรับรองตนเอง',
		errorCheckStatusCode: (code) => `กรุณาตรวจสอบคำขอในเมนู สถานะการยื่นแบบรับรองตนเอง (error code: ${code})`,
		fileSizeLimitTitle: 'ขนาดไฟล์เกินขีด จำกัด',
		fileSizeLimitText: 'ขนาดไฟล์รวมกันต้องไม่เกิน 300 MB',
		fileTypeErrorTitle: 'ชนิดไฟล์ไม่ถูกต้อง',
		fileTypeErrorText: 'ชนิดไฟล์ต้องเป็น PDF เท่านั้น',
		deleteFileTitle: 'คุณต้องการลบไฟล์นี้ใช่หรือไม่?',
		deleteFileText: 'คุณจะไม่สามารถกู้คืนไฟล์นี้ได้หากลบไปแล้ว',
		deleteFileConfirm: 'ใช่, ลบไฟล์นี้',
		deleteFileSuccess: 'ลบไฟล์สำเร็จ!',
		deleteFileSuccessText: 'ไฟล์ของคุณถูกลบแล้ว',
		successTitle: 'ยื่นแบบหนังสือรับรองตนเอง สำเร็จ',
		infoAlertTitle: 'ท่านสามารถศึกษาประกาศและกฎระเบียบที่เกี่ยวข้อง รวมถึงวิธีการยื่นอย่างละเอียดได้ที่',
		noPoaTitle: 'ท่านยังไม่ได้รับการมอบอำนาจจากสถานประกอบการ',
		noPoaText: 'ท่านยังไม่ได้รับการมอบอำนาจหรือสิทธิ์ ในการดำเนินการแทนสถานประกอบการ ทำให้ท่านไม่สามารถ ยื่นแบบหนังสือรับรองตนเอง แบบนิติบุคคล ได้ หากท่านต้องการดำเนินการแบบนิติบุคคล กรุณาติดต่อเจ้าหน้าที่ผู้ดูแลระบบ เพื่อดำเนินการมอบอำนาจก่อนดำเนินการต่อไป',
		requestAdditionalFileTitle: 'รายละเอียดการขอเอกสารเพิ่มเติมจากเจ้าหน้าที่',
		requestModifyInfoTitle: 'รายละเอียดการขอให้ปรับปรุงข้อมูลจากเจ้าหน้าที่',
		ejectRemarkTitle: 'รายละเอียดการไม่อนุมัติคำขอจากเจ้าหน้าที่',
		profileErrorMsg: (menu) => `ข้อมูลที่อยู่ไม่ถูกต้อง หรือรูปแบบผิด กรุณาตรวจสอบและปรับปรุงข้อมูลในเมนู "${menu}" และกรอกข้อมูลลงฟอร์มให้ถูกต้อง`,
		profileErrorMenu: 'ข้อมูลผู้ใช้งาน',
		profileErrorConfirm: 'แก้ไขข้อมูล',
		prefixMap: {
			'นาย': 'นาย',
			'นาง': 'นาง',
			'นางสาว': 'นางสาว',
			'ท่านผู้หญิง': 'ท่านผู้หญิง',
			'บริษัท': 'บริษัท',
			'ห้างหุ้นส่วน': 'ห้างหุ้นส่วน',
			'ห้างหุ้นส่วนจำกัด': 'ห้างหุ้นส่วนจำกัด',
			'อื่นๆ': 'อื่นๆ',
			'ร้าน': 'ร้าน',
			'ร้านค้า': 'ร้านค้า',
		},
	},
	sDocStatusNames: {},
	manage: {
		cancelTitle: 'ยกเลิกคำขอยื่นแบบรับรองตนเอง',
		cancelQuestion: (requestNo) => `คุณต้องการยกเลิกคำขอที่ ${requestNo} ใช่หรือไม่`,
		cancelWarning: 'หากท่านยกเลิกแล้วรายการคำขอนี้จะไม่สามารถดำเนินการต่อได้อีก',
		confirm: 'ตกลง',
		billRenewTitle: 'ทำรายการต่ออายุใบนำฝาก',
		billRenewFail: 'ระบบไม่สามารถจัดคิวต่ออายุใบนำฝากได้',
		pageTitle: 'สถานะการยื่นแบบรับรองตนเอง',
		inProgressTitle: 'แบบรับรองตนเองที่อยู่ระหว่างดำเนินการ',
		approvedTitle: 'แบบรับรองตนเองทีได้รับการอนุมัติแล้ว',
		colRequestNo: 'เลขที่คำขอ',
		colBrandName: 'ตราอักษร (Brand Name)',
		colProductModel: 'รุ่นของผลิตภัณฑ์',
		colSubmitDate: 'วันที่และเวลายื่นแบบ',
		colApproveDate: 'วันที่และเวลาได้รับอนุมัติ',
		colStatus: 'สถานะ',
		colActivity: 'กิจกรรม',
		statusIncomplete: 'คำขอไม่สมบูรณ์',
		statusDocAdded: 'เพิ่มเอกสารแล้ว',
		statusInfoUpdated: 'ปรับปรุงข้อมูลแล้ว',
		statusModifyDoc: 'ขอปรับปรุงเอกสาร',
		statusOverdue: 'เลยกำหนดชำระ',
		btnDetail: 'รายละเอียด',
		btnRejectReason: 'ดูเหตุผลที่ไม่อนุมัติ',
		btnAttachFile: 'แนบไฟล์เพิ่ม',
		btnUpdateInfo: 'ปรับปรุงข้อมูล',
		btnDownloadCert: 'ดาวน์โหลดหนังสือรับรอง',
		btnUpdatePayment: 'อัพเดทข้อมูลการชำระเงิน',
		btnDownloadBill: 'ดาวน์โหลดใบนำฝากชำระเงิน',
		btnRenewBill: 'ทำรายการใบนำฝากใหม่',
		btnRenewBillDisabledTooltip: 'ไม่สามารถทำรายการได้ เพราะคุณได้ทำรายการใบนำฝากใหม่ไปแล้ว',
		btnCancelRequest: 'ยกเลิกคำขอ',
		btnDownloadReceipt: 'ดาวน์โหลดใบเสร็จรับเงิน',
		waitTitle: 'กรุณารอสักครู่',
		processing: 'ระบบกำลังทำรายการ',
		billInquirySuccess: 'ทำการตรวจสอบการชำระเงินสำเร็จ',
		billInquirySuccessText: 'ตรวจพบการชำระเงินของท่านแล้ว กรุณารอระบบดำเนินการต่อ',
		billInquiryFail: 'ไม่พบข้อมูลการชำระเงินดังกล่าว',
		billInquiryFailText: 'ไม่พบการชำระเงินรายการนี้ หรือ ข้อมูลอาจจะล่าช้า กรุณารอสักครู่ และทำรายการใหม่ภายหลัง',
		billRenewSuccess: 'รับคำสั่งทำรายการใบนำฝากใหม่แล้ว ระบบกำลังส่งข้อมูลไปยัง SAP',
		cancelSuccess: 'ยกเลิกรายการคำขอสำเร็จ',
		cancelSuccessText: 'ระบบได้ทำการยกเลิกคำขอยื่นแบบรับรองตนเองของท่านแล้ว',
		cancelFail: 'ไม่สามารถยกเลิกรายการคำขอได้',
		cancelFailText: 'ระบบไม่สามารถทำรายการได้ กรุณาติดต่อเจ้าหน้าที่',
		noData: 'ไม่พบข้อมูล',
		loading: 'กำลังประมวลผลข้อมูล โปรดรอสักครู่..',
	},
	profile: {
		saveSuccess: 'บันทึกข้อมูลสำเร็จ',
	},
	profileCard: {
		header: 'รายละเอียดผู้ยื่นแบบรับรองตนเอง',
		senderTypeLabel: 'ประเภทของข้อมูลผู้ใช้งาน',
		normalPerson: 'บุคคลธรรมดา',
		organization: 'นิติบุคคล',
		shop: 'ร้านค้า',
		nationalID: 'เลขประจำตัวบัตรประชาชน',
		prefix: 'คำนำหน้าชื่อ',
		fullName: 'ชื่อ-นามสกุล',
		shopName: 'ชื่อร้านค้า',
		address: 'ที่อยู่',
		addressPlaceholder: 'บ้านเลขที่ / ตึก อาคาร / หมู่บ้าน / ซอย / ถนน',
		province: 'จังหวัด',
		district: 'อำเภอ / เขต',
		subdistrict: 'ตำบล / แขวง',
		zipcode: 'รหัสไปรษณีย์',
		phone: 'เบอร์โทรศัพท์',
		companyData: 'ข้อมูลบริษัท',
		shopData: 'ข้อมูลร้านค้า',
		branchData: 'ข้อมูลสาขา',
		taxID: 'เลขประจำตัวผู้เสียภาษีอากร',
		companyPrefix: 'คำนำหน้าชื่อบริษัท',
		shopType: 'ประเภทร้านค้า',
		companyName: 'ชื่อหน่วยงาน / ชื่อผู้ประกอบการ',
		branchNo: 'รหัสสาขา',
		branchNoPlaceholder: 'รหัสสาขา 5 หลัก',
		selectBranch: 'เลือกสาขา',
		savePersonal: 'บันทึกข้อมูลส่วนตัว',
		saveCompany: 'บันทึกข้อมูลบริษัท',
		saveShop: 'บันทึกข้อมูลร้านค้า',
		saveBranch: 'บันทึกข้อมูลสาขา',
		specify: 'ระบุ',
		other: 'อื่นๆ',
	},
	orgCard: {
		header: '1. รายละเอียดผู้ยื่นแบบรับรองตนเอง',
		editWarningTitle: 'การแก้ไขข้อมูลผู้ยื่นแบบรับรองตนเอง',
		editWarningMsg: (menu) => `หากข้อมูลในรายละเอียดด้านล่างไม่ตรงกับข้อมูลปัจจุบัน ผู้ใช้งานสามารถแก้ไขข้อมูลได้ที่เมนู "${menu}" ก่อนยื่นแบบรับรองตนเอง`,
		userInfoMenu: 'ข้อมูลผู้ใช้งาน',
		senderTypeLabel: 'ประเภทของผู้ยื่นหนังสือยืนยันตนเอง',
		normalPerson: 'บุคคลธรรมดา',
		organization: 'นิติบุคคล',
		shop: 'ร้านค้า',
		fullName: 'ชื่อ-นามสกุล',
		nationalID: 'เลขประจำตัวบัตรประชาชน',
		address: 'ที่อยู่',
		phone: 'เบอร์โทรศัพท์',
		taxID: 'เลขประจำตัวผู้เสียภาษีอากร',
		companyPrefix: 'คำนำหน้าชื่อบริษัท',
		shopType: 'ประเภทร้านค้า',
		companyName: 'ชื่อหน่วยงาน / ชื่อผู้ประกอบการ',
		shopName: 'ชื่อร้านค้า',
		branchNo: 'รหัสสาขา',
		selectBranch: 'เลือกสาขา',
		invalidAddressTitle: 'ข้อมูลที่อยู่ไม่ถูกต้อง หรือรูปแบบผิด',
		invalidAddressMsg: (menu) => `กรุณาตรวจสอบและปรับปรุงข้อมูลในเมนู "${menu}" และกรอกข้อมูลลงฟอร์มให้ถูกต้อง`,
		invalidAddressConfirm: 'แก้ไขข้อมูล',
		userInfoMenu2: 'ข้อมูลผู้ใช้งาน',
	},
	brandCard: {
		descriptionPlaceholder: 'เช่น Access Point / Wireless Earphone / Notebook Computer',
		header: '2.รายละเอียดของเครื่องโทรคมนาคมและอุปกรณ์',
		brandName: 'ตราอักษร (Brand Name)',
		model: 'แบบ/รุ่น (model)',
		description: 'รายละเอียดของสินค้า',
		groupType: 'กลุ่มประเภทเครื่องโทรคมนาคมและอุปกรณ์',
	},
	techType: {
		'ทั่วไป': 'ทั่วไป',
		'RLAN': 'RLAN',
		'RLAN Wifi 6e (ภายในอาคาร)': 'RLAN Wifi 6e (ภายในอาคาร)',
		'RLAN Wifi 6e (ภายในและภายนอกอาคาร)': 'RLAN Wifi 6e (ภายในและภายนอกอาคาร)',
		'RFID': 'RFID',
		'Non-RFID': 'Non-RFID',
		'UAS': 'UAS',
		'FOD Vehicle': 'FOD Vehicle',
		'radar': 'radar',
		'Fix link': 'Fix link',
		'Optical System': 'Optical System',
		'Studio-Transmitter Link': 'Studio-Transmitter Link',
		'wireless microphone': 'wireless microphone',
		'cordless telephone': 'cordless telephone',
		'on-site paging (Pocket Unit)': 'on-site paging (Pocket Unit)',
		'เครื่องส่งสัญญาณเสียง': 'เครื่องส่งสัญญาณเสียง',
		'เครื่องส่งสัญญาณภาพ หรือเครื่องส่งสัญญาณภาพและเสียง': 'เครื่องส่งสัญญาณภาพ หรือเครื่องส่งสัญญาณภาพและเสียง',
		'ตู้สาขาโทรศัพท์อัตโนมัติ (PABX)': 'ตู้สาขาโทรศัพท์อัตโนมัติ (PABX)',
		'ระบบโทรศัพท์กดปุ่ม (key telephone system)': 'ระบบโทรศัพท์กดปุ่ม (key telephone system)',
		'บริภัณฑ์ข้อมูลปลายทาง (data terminal equipment)': 'บริภัณฑ์ข้อมูลปลายทาง (data terminal equipment)',
		'เครืองโทรศัพท์ (telephone set)': 'เครืองโทรศัพท์ (telephone set)',
		'เครืองโทรสาร (facsimile equipment)': 'เครืองโทรสาร (facsimile equipment)',
		'เครืองโทรคมนาคมส่าหรับสายผู้เช่าดิจิทัลแบบต่าง ๆ (xDSL equipment)': 'เครืองโทรคมนาคมส่าหรับสายผู้เช่าดิจิทัลแบบต่าง ๆ (xDSL equipment)',
		'โมเด็ม (modem)': 'โมเด็ม (modem)',
	},
	powerUnitMap: {
		'ไม่มี': 'ไม่มี',
	},
	equipmentCard: {
		header: 'อุปกรณ์ย่านความถี่',
		addButton: 'เพิ่มอุปกรณ์ย่านความถี่',
		productType: 'ประเภทมาตรฐานเทคโนโลยี',
		frequency: 'คลื่นความถี่',
		power: 'กำลังส่ง',
		unit: 'หน่วย',
		relatedAnnouncement: 'ประกาศที่เกี่ยวข้อง',
		numberOnly: 'ตัวเลขเท่านั้น',
		invalidNumber: 'กรุณากรอกตัวเลขที่ถูกต้อง',
		exactValue: (value) => `ค่าต้องเท่ากับ ${value} dBm`,
		maxValue: (value, unit) => `ค่าต้องไม่เกิน ${value} ${unit}`,
		invalidUnit: (units) => `หน่วยต้องเป็น ${units}`,
		errorPower: (url) => `***ข้อมูลกำลังคลื่นความถี่ หรือกำลังส่งไม่ถูกต้อง โปรดกรอกกำลังส่งหรือหน่วยให้ถูกต้อง โดยท่านสามารถศึกษารายละเอียดเพิ่มเติมได้ที่ ${url} หรือสามารถสอบถามข้อมูลเพิ่มเติมได้ที่ email : SDoC@nbtc.go.th`,
	},
	documentCard: {
		header: 'เอกสารหลักฐานประกอบการรับรองตนเอง',
		subHeader: 'เอกสารแนบประกอบการรับรองตนเอง',
		uploadNote: '* อัพโหลดไฟล์ข้อมูลใน format .pdf เท่านั้น *',
		downloadAll: 'ดาวน์โหลดทั้งหมด',
		attachInfo: 'ข้อมูลเอกสารแนบ',
		namePlaceholder: 'โปรดตั้งชื่อเอกสาร*',
		selectFile: 'เลือกไฟล์',
		noFileSelected: 'ยังไม่ได้เลือกไฟล์',
		attach: 'แนบไฟล์',
		instructions: '* กรุณาแนบเอกสารประกอบการรับรองตนเองอย่างน้อย 2 ไฟล์\n* ขนาดไฟล์รวมกันต้องไม่เกิน 300 MB\n** หากเอกสารเป็นไฟล์ผลการทดสอบเครื่องโทรคมนาคม (Test Report) ขอให้ท่านตั้งชื่อเอกสารเป็นหมายเลขผลการทดสอบ เช่น Test Report No. : XXXXXXX',
		docName: 'ชื่อเอกสาร',
		save: 'บันทึก',
		additionalFile: 'เอกสารที่แนบเพิ่มเติม',
	},
	transactionCard: {
		header: 'รายการใบแจ้งหนี้',
		details: 'รายละเอียดรายการ',
		colRef1: 'หมายเลขอ้างอิง 1',
		colRef2: 'หมายเลขอ้างอิง 2',
		colCreateDate: 'วันที่สร้าง',
		colDueDate: 'วันหมดอายุ',
		colReceiveDate: 'วันที่รับเงิน',
		colInvoiceNo: 'ใบเสร็จรับเงิน',
		colStatus: 'สถานะ',
		statusWaiting: 'รอการชำระเงิน',
		statusExpired: 'หมดเวลาชำระเงิน',
		statusPaid: 'ชำระเงินแล้ว',
		statusSuccess: 'สำเร็จ',
		noData: 'ไม่พบข้อมูล',
		loading: 'กำลังประมวลผลข้อมูล โปรดรอสักครู่..',
		addReceiptBtn: 'เพิ่มใบเสร็จรับเงิน',
		addReceiptTitle: 'กรุณากรอกหมายเลขใบเสร็จรับเงิน',
		addReceiptPlaceholder: 'หมายเลขใบเสร็จรับเงิน',
		save: 'บันทึก',
		cancel: 'ยกเลิก',
		addReceiptRequired: 'กรุณากรอกหมายเลขใบเสร็จรับเงิน',
		addReceiptSuccess: 'บันทึกหมายเลขใบเสร็จรับเงินสำเร็จ',
		errorTitle: 'เกิดข้อผิดพลาด',
		errorRetry: 'กรุณาลองใหม่อีกครั้ง',
		ok: 'ตกลง',
	},
	sureModal: {
		cancel: 'ยกเลิก',
		confirm: 'ตกลง',
		processing: 'กำลังดำเนินการ...',
		progressLabel: 'ความคืบหน้าในการดำเนินการ',
		pleaseWait: 'โปรดรอสักครู่ ห้ามปิดหน้าต่างนี้ในขณะที่กำลังดำเนินการ',
	},
	auth: {
		unregisteredCompany: 'บริษัทนี้ไม่ได้ลงทะเบียนใช้งาน SDoC ไว้',
		privacyTitle: 'ประกาศความเป็นส่วนตัว (Privacy Notice) เวอร์ชั่น ๒',
		privacySummary: 'สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ ให้ความสำคัญกับการคุ้มครองข้อมูลส่วนบุคคลของท่าน (วันที่ประกาศใช้ ๑๙ ตุลาคม ๒๕๖๖)',
		for: 'สำหรับ',
		sdocTitle: 'การยื่นแบบรับรองตนเองของผู้ประกอบการ (SDoC)',
		loading: 'กำลังเข้าสู่ระบบ...',
		signInDigitalID: 'ยืนยันตัวตนด้วย Digital ID เพื่อเข้าสู่ระบบ',
		systemDesc: 'ระบบกลางการเชื่อมต่อข้อมูลกับหน่วยงานภายนอกแบบอัตโนมัติ',
		selectOperator: 'เลือกผู้ประกอบการ',
		acknowledged: 'ข้าพเจ้าได้อ่านและรับทราบแล้ว',
		accept: 'รับทราบ',
		updateTokenTitle: 'อัพเดทข้อมูลการมอบอำนาจ',
		updateTokenPlaceholder: 'ใส่ URL ที่ได้รับจากการเข้าสู่ระบบ',
		updateTokenConfirm: 'อัพเดท',
		updateTokenSuccess: 'อัพเดทข้อมูลสำเร็จ',
		maintenanceTitle: 'ประกาศปิดปรับปรุงระบบ',
		maintenanceBody: 'ประกาศแจ้งปิดระบบทำการปิดปรับปรุงระบบฉุกเฉิน ขออภัยในความไม่สะดวก ทางสำนักงาน กสทช. จะเร่งดำเนินการเพื่อให้ท่านสามารถยื่นคำขอรับบริการหรืออนุญาตได้โดยเร็วที่สุด',
		maintenanceOrg: 'สำนักงาน กสทช.',
		noPOATitle: 'โปรดทราบ',
		noPOAContent: 'คุณไม่ได้รับสิทธิ์การเข้าใช้งานระบบ SDoC',
		selectTitle: 'กรุณาเลือก',
		selectContent: 'คุณยังไม่ได้รับสิทธ์การมอำนาจจากบริษัท กรณีข้อมูลผิดพลาด กรุณาติดต่อเจ้าหน้าที่ 02-xxx-xxxx',
		taxId: 'เลขประจำตัวผู้เสียภาษี',
		authPeriod: 'ระยะเวลามอบอำนาจ',
		operatorName: 'ชื่อผู้ประกอบการ',
		individual: 'บุคคลธรรมดา',
		select: 'เลือก',
		viewShop: 'เรียกดูข้อมูลร้านค้า',
		to: 'ถึง',
		noExpiry: 'ไม่มีกำหนด',
		notInSystem: 'ไม่พบในระบบ',
		noShopTitle: 'ไม่พบข้อมูล',
		noShopText: 'ไม่พบข้อมูลร้านค้าจากเลขประจำตัวประชาชนของคุณ',
		shopErrorTitle: 'เกิดข้อผิดพลาด',
		shopErrorText: 'ไม่สามารถเรียกดูข้อมูลร้านค้าได้',
		ok: 'ตกลง',
		fetchError: 'ไม่สามารถเรียกข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
		close: 'ปิด',
		taxIdNumber: 'หมายเลขประจำตัวผู้เสียภาษี',
		companyName: 'ชื่อบริษัท*',
		companyAddress: 'ที่อยู่บริษัท*',
		back: 'ย้อนกลับ',
		confirmRegister: 'ยืนยันการลงทะเบียน',
		reloginRequiredTitle: 'โปรดเข้าสู่ระบบใหม่อีกครั้ง',
		reloginRequiredHeader: 'ฟังก์ชันข้อมูลร้านค้ารองรับการเข้าสู่ระบบแบบ Token',
		reloginRequiredBody: 'เนื่องจากท่านเข้าสู่ระบบในรูปแบบเดิม (Query String) ทำให้ไม่สามารถเชื่อมต่อข้อมูลร้านค้าได้ กรุณากดปุ่ม "เข้าสู่ระบบใหม่" เพื่อยืนยันตัวตนในรูปแบบ Token ผ่าน Service Portal',
		reloginButton: 'เข้าสู่ระบบใหม่',
		cancelButton: 'ยกเลิก',
	},
}

export default th
